import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import layoutContext from "../../../context/LayoutContext";
import { Container, Table } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import axios from "axios";
import { PRIMARY } from "../../../vars/vars";

const Distributors = () => {
  const [distributors, setDistributors] = useState([]);
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText("Gdzie kupić");
    const url =
      process.env.NODE_ENV === "production"
        ? "/scripts/distributors.php"
        : "http://dev.pedders.pl/scripts/distributors.php";

    axios.get(url + "?oz_website=pedders.pl").then((res) => {
      setDistributors(res.data);
    });
  }, []);

  const DistLink = ({ dist }) =>
    dist.website ? (
      <Link
        href={
          dist.website.includes("http")
            ? dist.website
            : "http://" + dist.website
        }
        target={"_blank"}
      >
        {dist.name}
      </Link>
    ) : (
      dist.name
    );

  return (
    <StyledDistributors>
      <Container>
        <UnderlinedHeader text={"Gdzie kupić"} bolder />
        <StyledTable striped bordered onCopy={(e) => e.preventDefault()}>
          <thead>
            <tr>
              <th>Państwo</th>
              <th>Nazwa firmy</th>
              <th>Specjalizacja</th>
              <th>Adres</th>
              <th>Telefon</th>
              <th>Adres email</th>
            </tr>
          </thead>
          <tbody>
            {distributors.map((dist) => (
              <tr key={dist.id}>
                <td>{dist.country}</td>
                <td>
                  <Type>{dist.type}</Type>
                  <div>
                    <DistLink dist={dist} />
                  </div>
                </td>
                <td>{dist.specialisation}</td>
                <td>
                  {dist.address1} <br /> {dist.address2}
                </td>
                <td>{dist.phone}</td>
                <td>{dist.email}</td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </Container>
    </StyledDistributors>
  );
};

export default Distributors;

const StyledDistributors = styled.section`
  padding-top: 30px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  line-height: 1.66;
`;

const Link = styled.a`
  &:hover {
    cursor: pointer;
    color: ${PRIMARY};
  }
`;

const StyledTable = styled(Table)`
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  text-align: left;
  user-select: none;
`;

const Type = styled.div`
  font-weight: 600;
`;
